import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
        &copy; 2025 Chaeyoung Yoon. All Rights Reserved.
      </footer>
  );
};

export default Footer;
